module.exports = __webpack_public_path__ + "static/media/spa-and-salon-chains_2.55ebd92f.svg";